import { toastr } from 'react-redux-toastr';
import { GEO_ACTION_TYPES, GEO_FIELD_NAMES } from './actionTypes';
import { DADATA_API_KEY } from '../../config/secrets';

const STORAGE_KEY = 'userGeoLocation';

export const geoActions = {
    requestLocation: () => ({
        type: GEO_ACTION_TYPES.REQUEST_LOCATION,
    }),

    receiveLocation: (data) => ({
        type: GEO_ACTION_TYPES.RECEIVE_LOCATION,
        data,
    }),

    locationError: (error) => ({
        type: GEO_ACTION_TYPES.LOCATION_ERROR,
        error,
    }),

    setRegion: (region, regionCode) => ({
        type: GEO_ACTION_TYPES.SET_REGION,
        region,
        regionCode,
    }),

    setCity: (city) => ({
        type: GEO_ACTION_TYPES.SET_CITY,
        city,
    }),

    loadFromStorage: (data) => ({
        type: GEO_ACTION_TYPES.LOAD_FROM_STORAGE,
        data,
    }),
};

const saveToStorage = (data) => {
    try {
        const existing = loadFromStorage() || {};
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            ...existing,
            ...data,
            savedAt: Date.now(),
        }));
    } catch (e) {
        console.warn('Не удалось сохранить геолокацию в localStorage:', e);
    }
};

const loadFromStorage = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const data = JSON.parse(stored);
            const hoursSinceUpdate = (Date.now() - data.savedAt) / (1000 * 60 * 60);
            if (hoursSinceUpdate < 168) {
                return data;
            }
        }
    } catch (e) {
        console.warn('Не удалось загрузить геолокацию из localStorage:', e);
    }
    return null;
};

const RUSSIA_REGIONS = {
    'MOW': 'Москва',
    'SPE': 'Санкт-Петербург',
    'SEV': 'Севастополь',

    'AD': 'Республика Адыгея',
    'AL': 'Республика Алтай',
    'BA': 'Республика Башкортостан',
    'BU': 'Республика Бурятия',
    'DA': 'Республика Дагестан',
    'DPR': 'Донецкая Народная Республика',
    'IN': 'Республика Ингушетия',
    'KB': 'Кабардино-Балкарская Республика',
    'KL': 'Республика Калмыкия',
    'KC': 'Карачаево-Черкесская Республика',
    'KR': 'Республика Карелия',
    'KO': 'Республика Коми',
    'KHE': 'Херсонская область',
    'LPR': 'Луганская Народная Республика',
    'ME': 'Республика Марий Эл',
    'MO': 'Республика Мордовия',
    'SA': 'Республика Саха (Якутия)',
    'SE': 'Республика Северная Осетия — Алания',
    'TAT': 'Республика Татарстан',
    'TY': 'Республика Тыва',
    'UD': 'Удмуртская Республика',
    'KK': 'Республика Хакасия',
    'CE': 'Чеченская Республика',
    'CU': 'Чувашская Республика',
    'CR': 'Республика Крым',
    'ZAP': 'Запорожская область',

    'ALT': 'Алтайский край',
    'ZAB': 'Забайкальский край',
    'KAM': 'Камчатский край',
    'KDA': 'Краснодарский край',
    'KYA': 'Красноярский край',
    'PER': 'Пермский край',
    'PRI': 'Приморский край',
    'STA': 'Ставропольский край',
    'KHA': 'Хабаровский край',

    'AMU': 'Амурская область',
    'ARK': 'Архангельская область',
    'AST': 'Астраханская область',
    'BEL': 'Белгородская область',
    'BRY': 'Брянская область',
    'VLA': 'Владимирская область',
    'VGG': 'Волгоградская область',
    'VLG': 'Вологодская область',
    'VOR': 'Воронежская область',
    'IVA': 'Ивановская область',
    'IRK': 'Иркутская область',
    'KGD': 'Калининградская область',
    'KLU': 'Калужская область',
    'KEM': 'Кемеровская область',
    'KIR': 'Кировская область',
    'KOS': 'Костромская область',
    'KGN': 'Курганская область',
    'KRS': 'Курская область',
    'LEN': 'Ленинградская область',
    'LIP': 'Липецкая область',
    'MAG': 'Магаданская область',
    'MOS': 'Московская область',
    'MUR': 'Мурманская область',
    'NIZ': 'Нижегородская область',
    'NGR': 'Новгородская область',
    'NVS': 'Новосибирская область',
    'OMS': 'Омская область',
    'ORE': 'Оренбургская область',
    'ORL': 'Орловская область',
    'PNZ': 'Пензенская область',
    'PSK': 'Псковская область',
    'ROS': 'Ростовская область',
    'RYA': 'Рязанская область',
    'SAM': 'Самарская область',
    'SAR': 'Саратовская область',
    'SAK': 'Сахалинская область',
    'SVE': 'Свердловская область',
    'SMO': 'Смоленская область',
    'TAM': 'Тамбовская область',
    'TVE': 'Тверская область',
    'TOM': 'Томская область',
    'TUL': 'Тульская область',
    'TYU': 'Тюменская область',
    'ULY': 'Ульяновская область',
    'CHE': 'Челябинская область',
    'YAR': 'Ярославская область',

    'NEN': 'Ненецкий автономный округ',
    'KHM': 'Ханты-Мансийский автономный округ — Югра',
    'CHU': 'Чукотский автономный округ',
    'YAN': 'Ямало-Ненецкий автономный округ',

    'YEV': 'Еврейская автономная область',
};

const normalizeRegionName = (regionName, regionCode) => {
    if (regionCode && RUSSIA_REGIONS[regionCode]) {
        return RUSSIA_REGIONS[regionCode];
    }
    return regionName || 'Неизвестный регион';
};

export const fetchGeoLocation = (forceRefresh = false) => (dispatch) => {
    if (!forceRefresh) {
        const cached = loadFromStorage();
        if (cached) {
            dispatch(geoActions.loadFromStorage(cached));
            return Promise.resolve(cached);
        }
    }

    dispatch(geoActions.requestLocation());

    return fetch('https://ipapi.co/json/')
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then((json) => {
            if (!json.error) {
                const isRussia = (json.country_code || '').toUpperCase() === 'RU';

                const locationData = isRussia
                    ? {
                        [GEO_FIELD_NAMES.COUNTRY]: json.country_name || 'Россия',
                        [GEO_FIELD_NAMES.COUNTRY_CODE]: json.country_code || 'RU',
                        [GEO_FIELD_NAMES.REGION]: normalizeRegionName(json.region, json.region_code),
                        [GEO_FIELD_NAMES.REGION_CODE]: json.region_code || '',
                        [GEO_FIELD_NAMES.CITY]: json.city || '',
                        [GEO_FIELD_NAMES.LATITUDE]: json.latitude || null,
                        [GEO_FIELD_NAMES.LONGITUDE]: json.longitude || null,
                        [GEO_FIELD_NAMES.TIMEZONE]: json.timezone || 'Europe/Moscow',
                        [GEO_FIELD_NAMES.ISP]: json.org || '',
                    }
                    : {
                        [GEO_FIELD_NAMES.COUNTRY]: 'Россия',
                        [GEO_FIELD_NAMES.COUNTRY_CODE]: 'RU',
                        [GEO_FIELD_NAMES.REGION]: 'Москва',
                        [GEO_FIELD_NAMES.REGION_CODE]: 'MOW',
                        [GEO_FIELD_NAMES.CITY]: 'Москва',
                        [GEO_FIELD_NAMES.LATITUDE]: 55.7558,
                        [GEO_FIELD_NAMES.LONGITUDE]: 37.6173,
                        [GEO_FIELD_NAMES.TIMEZONE]: 'Europe/Moscow',
                        [GEO_FIELD_NAMES.ISP]: json.org || '',
                    };

                dispatch(geoActions.receiveLocation(locationData));
                saveToStorage(locationData);
                return locationData;
            } else {
                throw new Error(json.message || 'Не удалось определить местоположение');
            }
        })
        .catch((error) => {
            console.error('Ошибка определения геолокации:', error);
            dispatch(geoActions.locationError(error.message));

            const defaultLocation = {
                [GEO_FIELD_NAMES.COUNTRY]: 'Россия',
                [GEO_FIELD_NAMES.COUNTRY_CODE]: 'RU',
                [GEO_FIELD_NAMES.REGION]: 'Краснодарский край',
                [GEO_FIELD_NAMES.REGION_CODE]: 'KDA',
                [GEO_FIELD_NAMES.CITY]: 'Краснодар',
                [GEO_FIELD_NAMES.LATITUDE]: 45.0355,
                [GEO_FIELD_NAMES.LONGITUDE]: 38.9753,
                [GEO_FIELD_NAMES.TIMEZONE]: 'Europe/Moscow',
                [GEO_FIELD_NAMES.ISP]: '',
            };

            dispatch(geoActions.receiveLocation(defaultLocation));
            return defaultLocation;
        });
};

const reverseGeocodeByCoords = (latitude, longitude, forceRefresh) => (dispatch) => {
    return fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Token ${DADATA_API_KEY}`,
        },
        body: JSON.stringify({ lat: latitude, lon: longitude, count: 1 }),
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`DaData HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then((json) => {
            const data = json?.suggestions?.[0]?.data;
            if (!data) {
                throw new Error('Не удалось определить регион по координатам');
            }

            const regionCode = (data.region_iso_code || '').replace(/^RU-/, '');
            const locationData = {
                [GEO_FIELD_NAMES.COUNTRY]: 'Россия',
                [GEO_FIELD_NAMES.COUNTRY_CODE]: 'RU',
                [GEO_FIELD_NAMES.REGION]: normalizeRegionName(data.region_with_type, regionCode),
                [GEO_FIELD_NAMES.REGION_CODE]: regionCode,
                [GEO_FIELD_NAMES.CITY]: data.city || data.settlement || data.region || '',
                [GEO_FIELD_NAMES.LATITUDE]: parseFloat(data.geo_lat) || latitude,
                [GEO_FIELD_NAMES.LONGITUDE]: parseFloat(data.geo_lon) || longitude,
                [GEO_FIELD_NAMES.TIMEZONE]: 'Europe/Moscow',
                [GEO_FIELD_NAMES.ISP]: '',
            };

            dispatch(geoActions.receiveLocation(locationData));
            saveToStorage(locationData);
            return locationData;
        })
        .catch((error) => {
            console.error('Ошибка обратного геокодирования:', error);
            return dispatch(fetchGeoLocation(forceRefresh));
        });
};

export const detectLocationByGeo = (forceRefresh = true) => (dispatch) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
        return dispatch(fetchGeoLocation(forceRefresh));
    }

    dispatch(geoActions.requestLocation());

    return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                resolve(dispatch(reverseGeocodeByCoords(latitude, longitude, forceRefresh)));
            },
            (error) => {
                console.warn('Геолокация недоступна, переходим на определение по IP:', error.message);
                resolve(dispatch(fetchGeoLocation(forceRefresh)));
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
        );
    });
};

export const setUserRegion = (region, regionCode) => (dispatch) => {
    dispatch(geoActions.setRegion(region, regionCode));

    saveToStorage({
        [GEO_FIELD_NAMES.REGION]: region,
        [GEO_FIELD_NAMES.REGION_CODE]: regionCode,
        isManuallySet: true,
    });
};

export const setUserCity = (city) => (dispatch) => {
    dispatch(geoActions.setCity(city));

    saveToStorage({
        [GEO_FIELD_NAMES.CITY]: city,
    });
};

export const initGeoLocation = () => (dispatch) => {
    const cached = loadFromStorage();
    if (cached && cached[GEO_FIELD_NAMES.REGION]) {
        dispatch(geoActions.loadFromStorage(cached));
    } else {
        dispatch(fetchGeoLocation());
    }
};

export const RUSSIA_REGIONS_LIST = Object.entries(RUSSIA_REGIONS).map(([code, name]) => ({
    key: code,
    value: code,
    text: name,
})).sort((a, b) => a.text.localeCompare(b.text, 'ru'));